<template>
  <div class="post-order-container">
    <el-card class="order-card">
      <div slot="header" class="card-header">
        <span class="header-title">Purchase Post</span>
      </div>

      <div class="order-content">
        <!-- Post Preview Section -->
        <div class="post-preview">
          <el-card class="preview-card" shadow="hover">
            <div class="post-info">
              <div class="post-author">
                <el-avatar :size="40" :src="post.authorAvatar">
                  {{ post.user_name ? post.user_name.charAt(0) : 'U' }}
                </el-avatar>
                <div class="author-info">
                  <span class="author-name">{{ post.user_name || 'Unknown Author' }}</span>
                </div>
              </div>
              <h2 class="post-title">{{ post.title || 'Untitled Post' }}</h2>
              
              
            </div>
          </el-card>
        </div>

        <!-- Payment Details Section -->
        <div class="payment-details">
          <el-card class="payment-card">
            <h3 class="section-title">Payment Details</h3>
            
            <div class="price-summary">
              <div class="price-row">
                <span>Price:</span>
                <span class="price">${{ post.token_price || 0 }} Tokens</span>
              </div>



            </div>

            

            <div class="order-actions">
              <el-button type="text" @click="goBack">Cancel</el-button>
              <el-button type="primary" @click="processOrder" :loading="isProcessing">
                Complete Purchase
              </el-button>
            </div>
          </el-card>
        </div>
      </div>
    </el-card>

    <!-- Order Success Dialog -->
    <el-dialog
      title="Order Completed"
      :visible.sync="orderSuccessDialog"
      width="400px"
      :show-close="false"
      center
    >
      <div class="success-content">
        <i class="el-icon-success success-icon"></i>
        <h3>Thank you for your purchase!</h3>
        <p>You now have access to the full content of this post.</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="viewPost">View Post</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postRequest } from '@/apis/front';

export default {
  name: 'PostOrder',
  data() {
    return {
      postId: null,
      post: {
        title: '',
        user_name: '',
        authorAvatar: '',
        usd_price: 0,
        preview_content: ''
      },
      discount: 0,
      paymentMethod: 'credit',
      userBalance: 0,
      creditCardForm: {
        cardNumber: '',
        expiry: '',
        cvv: '',
        name: ''
      },
      creditCardRules: {
        cardNumber: [
          { required: true, message: 'Please enter your card number', trigger: 'blur' },
          { pattern: /^\d{13,19}$/, message: 'Please enter a valid card number', trigger: 'blur' }
        ],
        expiry: [
          { required: true, message: 'Please enter expiry date', trigger: 'blur' },
          { pattern: /^(0[1-9]|1[0-2])\/([0-9]{2})$/, message: 'Please use MM/YY format', trigger: 'blur' }
        ],
        cvv: [
          { required: true, message: 'Please enter CVV', trigger: 'blur' },
          { pattern: /^\d{3,4}$/, message: 'CVV must be 3 or 4 digits', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'Please enter cardholder name', trigger: 'blur' }
        ]
      },
      isProcessing: false,
      orderSuccessDialog: false,
      orderId: null,
      
    };
  },
  computed: {

  },
  created() {
    this.postId = this.$route.query.id;
    this.fetchPostDetails();
    
  },
  methods: {
    async fetchPostDetails() {
      try {
        this.$loading({
          lock: true,
          text: 'Loading post details...',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });

        const response = await postRequest('getPostPaymentInfo', {
          post_id: this.postId,
          user_id: this.$store.state.user_id
        });

        if (response.data.code === 0) {
          this.post = response.data.data;
          // Check if user has any applicable discounts
          // Check if user already owns the post
          const orderResponse = await postRequest('createPostOrder', {
            user_id: this.$store.state.user_id,
            post_id: this.postId
          });

          if (orderResponse.data.code === 0) {
            // Order created successfully
            this.orderId = (orderResponse.data.data._id.$oid || orderResponse.data.data._id.$id);
          } else if (orderResponse.data.code === -1) {
            // User already owns the post
            this.$message.warning('You already own this post');
            this.goBack();
          } else {
            throw new Error(orderResponse.data.message || 'Failed to create order');
          }
          
        } else {
          throw new Error(response.data.msg || 'Failed to load post details');
        }
      } catch (error) {
        console.error('Error fetching post details:', error);
        this.$message.error('Failed to load post details');
        this.goBack();
      } finally {
        this.$loading().close();
      }
    },

    


    goBack() {
      this.$router.push(`/post?id=${this.postId}`);
    },



    async processOrder() {
      try {
        this.isProcessing = true;

        // Process the order
        const processResponse = await postRequest('processPostOrder', {
          order_id: this.orderId
        });

        if (processResponse.data.code === 0) {
          // Show success dialog
          this.orderSuccessDialog = true;
          this.isProcessing = false;
        } else if (processResponse.data.code === -1) {
          if (processResponse.data.msg.includes('Insufficient')) {
            this.$message.error('Insufficient token balance');
          } else {
            this.$message.error(processResponse.data.msg || 'Failed to process order');
          }
          this.isProcessing = false;
        } else {
          throw new Error(processResponse.data.msg || 'Failed to process order');
        }
      } catch (error) {
        console.error('Error processing order:', error);
        this.$message.error('Failed to process order');
        this.isProcessing = false;
      }
    },

    viewPost() {
      this.orderSuccessDialog = false;
      this.$router.push(`/post?id=${this.postId}`);
    }
  }
};
</script>

<style scoped>
.post-order-container {
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 20px;
}

.order-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
}

.order-content {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.post-preview, .payment-details {
  flex: 1;
}

.preview-card {
  height: 100%;
}

.post-author {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.author-info {
  margin-left: 10px;
}

.author-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}

.post-title {
  font-size: 20px;
  margin: 0 0 20px 0;
  color: #303133;
  line-height: 1.4;
}

.preview-content {
  max-height: 300px;
  overflow-y: auto;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 20px;
}

.no-preview {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 150px;
  color: #909399;
}

.no-preview i {
  font-size: 40px;
  margin-bottom: 10px;
}

.section-title {
  font-size: 18px;
  margin: 0 0 20px 0;
  color: #303133;
  border-bottom: 1px solid #EBEEF5;
  padding-bottom: 10px;
}

.price-summary {
  margin-bottom: 30px;
}

.price-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 16px;
  color: #606266;
}

.price-row.discount {
  color: #67C23A;
}

.price-row.total {
  font-weight: 600;
  color: #303133;
  border-top: 1px dashed #EBEEF5;
  padding-top: 10px;
  margin-top: 10px;
}

.payment-method {
  margin-bottom: 20px;
}

.payment-method h4 {
  margin: 0 0 15px 0;
  color: #606266;
}

.credit-card-form {
  margin-top: 20px;
}

.form-row {
  display: flex;
  gap: 15px;
}

.form-row .el-form-item {
  flex: 1;
}

.order-actions {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  margin-top: 30px;
}

.success-content {
  text-align: center;
  padding: 20px 0;
}

.success-icon {
  font-size: 60px;
  color: #67C23A;
  margin-bottom: 20px;
}

/* Responsive styles */
@media (max-width: 768px) {
  .order-content {
    flex-direction: column;
  }
  
  .form-row {
    flex-direction: column;
    gap: 0;
  }
}
</style> 